<template>
  <div
    :class="`
      loader-container
      ${small ? 'small' : 'big'}
    `"
  >
    <div v-for="n in 4" :key="n" class="bar" :class="`bar-${n}`" />
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style scoped>
@reference "@/assets/css/tailwind.css";
.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px; /* Reduced gap to match thinner bars */
}

.small {
  height: 20px;
  width: 80px;
}

.big {
  height: 40px;
  width: 160px;
}

.bar {
  width: 10%; /* Thinner bars */
  height: 100%;
  background-color: #750800;
  animation:
    jump 0.8s ease-in-out infinite,
    colorChange 1.6s ease-in-out infinite alternate;
  transform-origin: bottom;
}

.bar-1 {
  animation-delay: 0.1s;
}

.bar-2 {
  animation-delay: 0.2s;
}

.bar-3 {
  animation-delay: 0.3s;
}

.bar-4 {
  animation-delay: 0.4s;
}

@keyframes jump {
  0%,
  100% {
    transform: translateY(0) scaleY(1);
  }
  50% {
    transform: translateY(-60%) scaleY(1.2);
  }
}

@keyframes colorChange {
  0% {
    background-color: #750800;
  }
  100% {
    background-color: #ffffff;
  }
}
</style>
